import React from 'react';
import p from '../../styles/renewal/OnePage.module.css';
import { DOCUMENTS, NOTICES, PROCESS_STEPS } from './data';

/** 시안 #guide — 절차 / 준비 서류 / 유의사항 */
const Process = ({ onNavigate }) => (
  <>
    <section className={`${p.section} ${p.reveal}`}>
      <div className={p.head}>
        <div className={p.badge}>PROCESS</div>
        <h2 className={p.title}>
          심사부터 이용까지,
          <br />
          오퍼그룹에서 안내해드립니다.
        </h2>
        <p className={p.lead}>
          오퍼그룹이 직접 심사하고 계약하며, 이용 중 납부 관리까지 함께합니다.
        </p>
      </div>

      <div className={p.grid4}>
        {PROCESS_STEPS.map((step) => (
          <div className={`${p.card} ${p.stepCard}`} key={step.no}>
            <div className={p.numCircle}>{step.no}</div>
            <div className={p.stepTitle}>{step.title}</div>
            <p className={p.stepText}>{step.body}</p>
          </div>
        ))}
      </div>
    </section>

    <section className={`${p.section} ${p.sectionSub} ${p.reveal}`}>
      <h2 className={p.titleSm}>준비 서류</h2>

      <div className={p.table}>
        <div className={`${p.tRow} ${p.tRowDoc} ${p.tHead}`}>
          <div>구분</div>
          <div>서류</div>
        </div>
        {DOCUMENTS.map((row) => (
          <div className={`${p.tRow} ${p.tRowDoc}`} key={row.type}>
            <div className={p.tLabel}>{row.type}</div>
            <div className={p.tLegacy}>{row.doc}</div>
          </div>
        ))}
      </div>

      <div className={p.note}>
        * 심사 과정에서 추가 서류가 필요할 수 있으며, 요청 시 사유를 함께 안내드립니다.
      </div>
    </section>

    <section className={`${p.section} ${p.sectionSub} ${p.sectionEnd} ${p.reveal}`}>
      <h2 className={p.titleSm}>유의사항</h2>

      <div className={p.gridAuto}>
        {NOTICES.map((item) => (
          <div className={`${p.card} ${p.noticeBox}`} key={item.title}>
            <div className={p.stepTitle}>{item.title}</div>
            <p className={p.cardText}>{item.body}</p>
          </div>
        ))}
      </div>

      <button
        type="button"
        className={`${p.btn} ${p.btnPrimary} ${p.ctaSpaced}`}
        onClick={() => onNavigate('contact')}
      >
        무료 상담 신청하기
      </button>
    </section>
  </>
);

export default Process;
